import { render, staticRenderFns } from "./troubleAplplyMIne.vue?vue&type=template&id=47fc6624&scoped=true"
import script from "./troubleAplplyMIne.vue?vue&type=script&lang=js"
export * from "./troubleAplplyMIne.vue?vue&type=script&lang=js"
import style0 from "./troubleAplplyMIne.vue?vue&type=style&index=0&id=47fc6624&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47fc6624",
  null
  
)

export default component.exports